import { IGetAllThreshold } from "../../models/response/IAdminResponse";

export const initialState: IGetAllThreshold = {
    Threshold: [],
    };